export function listPunchPermits(permits) {
  return Array.isArray(permits)
    ? permits.filter((permit) => permit?.startTime || permit?.endTime)
    : [];
}

export function formatPermitCoverLabel(permit) {
  const from = permit?.startTime || "—";
  const to = permit?.endTime || "—";
  const kind = permit?.isCompensatory ? "إذن تعويضي" : "إذن";
  return `${kind} · مغطى من ${from} إلى ${to}`;
}

export function formatPunchPermitCoverText(permits) {
  const list = listPunchPermits(permits);
  if (!list.length) return "";
  return list.map(formatPermitCoverLabel).join("، ");
}
